// extracted by mini-css-extract-plugin
module.exports = {"iconscontainer":"socialIcons-module--iconscontainer--3qC6O","iconscontainerBlock":"socialIcons-module--iconscontainerBlock--Lzpb5"};